import React from 'react';
import classNames from 'classnames';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import styles from 'components/admin/deviceDashboard/deviceEditor/DeviceSimulator.module.scss';

const MachineTypeSelection = (props) => {
  const {
    onBack,
    onNext,
    onValueChange,
    selectedMachineType,
  } = props;

  const machineTypes = ['DRYER', 'WASHER'];

  return (
    <>
      <header className={styles.header}>
        <h4>Choose your machine type</h4>
      </header>
      <main className={styles.main}>
        <section className={styles.section}>
          <p>Select whether the machine you want to create will be a washer or dryer</p>
          <Autocomplete
            disablePortal
            id="autocomplete-choose-machine-type"
            options={machineTypes}
            sx={{ width: '300px' }}
            onChange={(event, value) => {
                onValueChange(value);
            }}
            renderInput={(params) => <TextField {...params} label="Machine Type" />}
            value={selectedMachineType}
          />
        </section>
      </main>
      <footer className={styles.footer}>
        <p className={styles.backButton} onClick={onBack}>
          Back
        </p>
        <button
          className={classNames(styles.backButton, {
            disabled: !selectedMachineType,
          })}
          disabled={!selectedMachineType}
          onClick={onNext}
        >
          Next
        </button>
      </footer>
    </>
  );
};

export default MachineTypeSelection;
